import { OFFER_TIER } from '@amzn/sss-website-theme';

/**
 * Maps an offer tier to its translation key for the badge copy.
 * Returns undefined for tiers that should not display a badge (e.g. BASE).
 */
export const OFFER_TIER_BADGE_KEY: Record<string, string | undefined> = {
  [OFFER_TIER.BASE]: undefined,
  [OFFER_TIER.TCP]: 'product_signatory_price_tag',
};
